module.exports = "/_next/static/images/98627083da1e0e321de5e18240f828f2-rewards-illustration@3x.png.webp";